export const productsReducer = (state = {loading: false, resultproduct: null, products: [], product: null, total: 0} , action) => {
    switch (action.type) {
        case 'PRODUCT_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                products: action.payload.products || [],
                total: action.payload.total || 0
            }
        case 'PRODUCT_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                product: action.payload || null
            }
        case 'PRODUCT_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                resultproduct: action.payload.message,
                product: action.payload.product,
                products: [...state.products, action.payload.product],
            }
        case 'PRODUCT_EDIT_SUCCESS':
            if(action.payload.product){
                return {
                    ...state,
                    loading: false,
                    resultproduct: action.payload.message,
                    product: action.payload.product,
                    products: state.products.map(product => product._id === action.payload.product._id ? action.payload.product : product),
                }
            }else{
                return {
                    ...state,
                    loading: false,
                    resultproduct: action.payload.message || action.payload
                }
            }
        case 'PRODUCT_AI_FILL_SUCCESS':
            return {
                ...state,
                loading: false,
                resultproduct: 'aiFillReady',
                product: state.product
                    ? {
                        ...state.product,
                        attributes: action.payload.filledAttributes,
                        sources: Array.isArray(action.payload.sources)
                            ? action.payload.sources.join(', ')
                            : (action.payload.sources || state.product.sources),
                        imageUrl: action.payload.imageUrl || state.product.imageUrl,
                        pdfUrl: action.payload.pdfUrl || state.product.pdfUrl,
                    }
                    : state.product,
            }
        case 'PRODUCT_IMPORT_SUCCESS':
            return {
                ...state,
                loading: false,
                resultproduct: action.payload.message,
                products: [...state.products, ...(action.payload.products || [])],
                total: state.total + (action.payload.products ? action.payload.products.length : 0)
            }
        case 'PRODUCT_RESET_RESULT':
            return {
                ...state,
                resultproduct: null
            }
        case 'PRODUCT_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'PRODUCT_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        case 'PRODUCT_ERROR':
            return {
                ...state,
                loading: false,
                resultproduct: action.payload
            }
        default:
            return state
    }
}
